import { createSlice as createSliceOriginal } from "@reduxjs/toolkit";

/**
 * @typedef {import("@reduxjs/toolkit").Slice} Slice
 */

/**
 * Wrapper around Redux Toolkit's createSlice.
 *
 * @param {Object} options - Slice configuration object.
 * @return {Slice} The created slice.
 */
export const createSlice = (options) => {
  return createSliceOriginal(options);
};
